import React from 'react';

import DecimalForConceptos from '../../../../support/impuestos/DecimalForConceptos';

const ConceptoTraslado = ({ data }) => {
  return (
    <div>
      { data.Impuesto } { data.TasaOCuota }

      { data.TipoFactor === 'Exento' && (
        <span> Exento </span>
      )}

      { data.TipoFactor !== 'Exento' && (
        <span>
          { ' | ' }
          { DecimalForConceptos.make(data.Importe).toString() }
        </span>
      )}
      <div className="py-1"></div>
    </div>
  )
}

const ConceptoTraslados = ({ data = [] }) => {

  const renderTraslado = (item) => {
    return <ConceptoTraslado key={ `T-${item.Impuesto}` } data={ item } />
  }

  return (
    <>
      { data.length > 0 && (
        <div>
            <strong>Traslados: </strong>
            <br/>
            { data.map(renderTraslado) }
        </div>
      )}
    </>
  )
}

export default ConceptoTraslados
